// import { customerAdministration } from "state_management"
import { request } from "utils/request"
import { createMap, addToMap, replaceInMap, asyncAction, getRange } from "./common"
import { getState } from "storeAccess"

export const MemberRoles = {
  MEMBER: "member",
  PLANNER: "planner",
  VIEW_ONLY: "view_only",
}

const initialState = {}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "members/fetch":
      return createMap(action.res)
    case "members/create":
      return addToMap(state, action.res)
    case "members/createAsAdmin":
      return state // Noop
    case "members/archive":
    case "members/edit":
    case "members/updateCredentials":
      return replaceInMap(state, action.res)
    case "members/fetchOrder":
      return state
    case "members/editOrder":
      return state
    case "auth/logout":
      return initialState
    default:
      return state
  }
}

export function externalBookingsReducer(state = [], action) {
  switch (action.type) {
    case "members/fetchExternalBookings":
      return action.res
    case "auth/logout":
      return []
    default:
      return state
  }
}

export const fetch = asyncAction("members/fetch", (_dispatch) => {
  const state = getState()
  const [after, before] = getRange(
    state.visual.scheduleMondayDate,
    state.visual.scheduleWithWeekend,
    state.visual.scheduleWithWeek
  )
  return request("GET", `/members?after=${after}&before=${before}`).then((res) => res.items)
})

export const createAsAdmin = asyncAction("members/createAsAdmin", (dispatch, input) => {
  return request("POST", "/members", { input }).then((res) => {
    // dispatch(customerAdministration.fetchCustomers())
    return res.member
  })
})

export const create = asyncAction("members/create", (dispatch, input) => {
  return request("POST", "/members", { input }).then((res) => res.member)
})

export const edit = asyncAction("members/edit", (dispatch, id, patch) => {
  return request("PATCH", `/member/${id}`, { patch }).then((res) => res.member)
})

export const updateCredentials = asyncAction("members/updateCredentials", (dispatch, id, patch) => {
  return request("PATCH", `/member/${id}/update-credentials`, { patch }).then((res) => res.member)
})

// SPEC-057 L2 — the planner/admin "help" path after the credential lockdown: the server sends a
// welcome mail (never-used account) or a reset mail, its choice; nobody ever sees a password.
export const sendPasswordMail = asyncAction("members/sendPasswordMail", (dispatch, id) => {
  return request("POST", `/member/${id}/send-password-mail`)
})

// SPEC-057 L2 — self-service email change, step 1: re-auth with own password; the backend sends
// a confirmation code to the NEW address (the old one keeps working until step 2 confirms).
export const requestEmailChange = asyncAction("members/requestEmailChange", (dispatch, password, newEmail) => {
  return request("POST", `/member/request-email-change`, { input: { password, newEmail } })
})

// SPEC-057 L2 — self-service email change, step 2: the code from the new mailbox flips the
// address. The backend stamps last_logout, so the session may end right after — the auth
// reducer's UnauthorizedError handling takes the user to the login screen cleanly.
export const confirmEmailChange = asyncAction("members/confirmEmailChange", (dispatch, code) => {
  return request("POST", `/member/confirm-email-change`, { input: { code } })
})

export const archive = asyncAction("members/archive", (dispatch, id) => {
  return request("POST", `/member/${id}/archive`).then((res) => res.member)
})

export const fetchOrder = asyncAction("members/fetchOrder", (_dispatch) => {
  return request("GET", "/members/order").then((res) => res)
})

export const editOrder = asyncAction("members/editOrder", (dispatch, input) => {
  return request("POST", "/members/order", { input }).then((res) => {
    dispatch(fetch())
    return res.items
  })
})

export const fetchExternalBookings = asyncAction("members/fetchExternalBookings", (_dispatch) => {
  const state = getState()
  const [after, before] = getRange(
    state.visual.scheduleMondayDate,
    state.visual.scheduleWithWeekend,
    state.visual.scheduleWithWeek
  )
  return request("GET", `/members/external-bookings?after=${after}&before=${before}`).then((res) => res.items)
})
